import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketplaceItemStatus, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { LoyaltyIconModule } from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { RouterModule } from '@angular/router';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/router';
import * as ɵngcc2 from '@fgb/portal-component-library/src/lib/directives';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/shared/loyalty-icon';
import * as ɵngcc4 from '@fgb/portal-component-library/src/lib/pipes';
import * as ɵngcc5 from '@ngx-translate/core';
class MarketplaceListItemComponent {
    constructor() {
        this.ignoreLink = false;
    }
    ngOnInit() {
        this._updateTheme();
        this._updateStatusText();
    }
    _updateStatusText() {
        var _a, _b, _c, _d;
        switch ((_a = this.marketplaceItem) === null || _a === void 0 ? void 0 : _a.Status) {
            case MarketplaceItemStatus.SoldOut:
                this.statusText = 'marketplace.redeem.sold.out';
                break;
            case MarketplaceItemStatus.NotEnoughPoints:
                this.statusText = 'marketplace.redeem.not.enough.points';
                break;
            case MarketplaceItemStatus.ComingSoon:
                this.statusText = 'marketplace.redeem.coming.soon';
                break;
            case MarketplaceItemStatus.MemberLimitReached:
                this.statusText = 'marketplace.redeem.member.limit';
                break;
            case MarketplaceItemStatus.AllInBasket:
                this.statusText = 'marketplace.redeem.all.in.basket';
            default:
                if (((_b = this.marketplaceItem) === null || _b === void 0 ? void 0 : _b.theme) === 'mp-event' || ((_c = this.marketplaceItem) === null || _c === void 0 ? void 0 : _c.theme) === 'mp-virtual-event') {
                    this.statusText = 'marketplace.redeem.event';
                }
                else if (((_d = this.marketplaceItem) === null || _d === void 0 ? void 0 : _d.theme) === 'mp-product') {
                    this.statusText = 'marketplace.redeem.product';
                }
                else {
                    this.statusText = 'marketplace.redeem.marketplace';
                }
        }
    }
    _updateTheme() {
        var _a, _b;
        if (((_a = this.marketplaceItem) === null || _a === void 0 ? void 0 : _a.Status) === MarketplaceItemStatus.Available) {
            this.theme = (_b = this.marketplaceItem) === null || _b === void 0 ? void 0 : _b.theme;
        }
        else {
            this.theme = 'disabled';
        }
    }
}
MarketplaceListItemComponent.ɵfac = function MarketplaceListItemComponent_Factory(t) { return new (t || MarketplaceListItemComponent)(); };
MarketplaceListItemComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: MarketplaceListItemComponent, selectors: [["fgbcl-marketplace-list-item"]], inputs: { ignoreLink: "ignoreLink", marketplaceItem: "marketplaceItem" }, decls: 35, vars: 27, consts: [[3, "routerLink"], [1, "card", "loyalty", "border-0", "shadow-sm"], ["alt", "", "draggable", "false", 1, "card-img-top", 3, "src", "useDefault", "loyaltyType"], [1, "corner-icon", 3, "loyaltyType"], [1, "card-img-overlay", "bg-loyalty-gradient", "text-white", "px-3", "pb-2", "pt-3", "rounded-0"], [1, "mb-3", "font-weight-bold"], [1, "row"], [1, "col-6", "d-flex"], ["aria-hidden", "true", 1, "icon", "material-icons", "reward-detail-icons"], [1, "accessibility-only"], [1, "pl-1", "font-weight-normal"], ["aria-hidden", "true"], [1, "mx-1", "font-weight-bold"]], template: function MarketplaceListItemComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "a", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelement(3, "img", 2);
        ɵngcc0.ɵɵpipe(4, "contentImage");
        ɵngcc0.ɵɵelementStart(5, "div");
        ɵngcc0.ɵɵelement(6, "fgbcl-loyalty-icon", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "div", 4);
        ɵngcc0.ɵɵelementStart(8, "div", 5);
        ɵngcc0.ɵɵtext(9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 6);
        ɵngcc0.ɵɵelementStart(11, "div", 7);
        ɵngcc0.ɵɵelementStart(12, "span", 8);
        ɵngcc0.ɵɵtext(13, "emoji_events");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(14, "label", 9);
        ɵngcc0.ɵɵtext(15, "Points Value: ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(16, "span", 10);
        ɵngcc0.ɵɵtext(17);
        ɵngcc0.ɵɵpipe(18, "FortressCurrencyPipe");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 7);
        ɵngcc0.ɵɵelementStart(20, "span", 8);
        ɵngcc0.ɵɵtext(21, "local_offer");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(22, "label", 9);
        ɵngcc0.ɵɵtext(23, "Stock Availability: ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(24, "span", 10);
        ɵngcc0.ɵɵtext(25);
        ɵngcc0.ɵɵelementStart(26, "span", 11);
        ɵngcc0.ɵɵtext(27, "/");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(28, "label", 9);
        ɵngcc0.ɵɵtext(29, "Out of");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtext(30);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(31, "div");
        ɵngcc0.ɵɵelementStart(32, "span", 12);
        ɵngcc0.ɵɵtext(33);
        ɵngcc0.ɵɵpipe(34, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("routerLink", "/rewards/marketplace/details/" + ctx.marketplaceItem.Id);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind3(4, 18, ctx.marketplaceItem.ItemImageURL, "7", "marketplace"), ɵngcc0.ɵɵsanitizeUrl)("useDefault", true)("loyaltyType", "marketplace");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate2("corner-icon-container ", "bg-" + ctx.marketplaceItem.theme, " ", "text-on-" + ctx.marketplaceItem.theme, "");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("loyaltyType", ctx.marketplaceItem.ProcessProviderId);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ctx.marketplaceItem.DisplayName);
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(18, 22, ctx.marketplaceItem.PointValue, "PTS"));
        ɵngcc0.ɵɵadvance(8);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.marketplaceItem.AvailabilityCount, " ");
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.marketplaceItem.StockCount, " ");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate2("cta ", "bg-" + ctx.theme, " ", "text-on-" + ctx.theme, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(34, 25, ctx.statusText));
    } }, directives: [ɵngcc1.RouterLinkWithHref, ɵngcc2.ImgDefaultDirective, ɵngcc3.LoyaltyIconComponent], pipes: [ɵngcc4.ContentImagePipe, ɵngcc4.FortressCurrencyPipe, ɵngcc5.TranslatePipe], styles: [""] });
MarketplaceListItemComponent.ctorParameters = () => [];
MarketplaceListItemComponent.propDecorators = {
    marketplaceItem: [{ type: Input }],
    ignoreLink: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceListItemComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-marketplace-list-item',
                template: "<a [routerLink]=\"'/rewards/marketplace/details/' + marketplaceItem.Id\">\r\n  <div class=\"card loyalty border-0 shadow-sm\">\r\n    <div>\r\n      <img\r\n        class=\"card-img-top\"\r\n        [src]=\"marketplaceItem.ItemImageURL | contentImage: '7':'marketplace'\"\r\n        alt=\"\"\r\n        [useDefault]=\"true\"\r\n        [loyaltyType]=\"'marketplace'\"\r\n        draggable=\"false\"\r\n      />\r\n      <div class=\"corner-icon-container {{ 'bg-' + marketplaceItem.theme }} {{ 'text-on-' + marketplaceItem.theme }}\">\r\n        <fgbcl-loyalty-icon class=\"corner-icon\" [loyaltyType]=\"marketplaceItem.ProcessProviderId\"></fgbcl-loyalty-icon>\r\n      </div>\r\n      <div class=\"card-img-overlay bg-loyalty-gradient text-white px-3 pb-2 pt-3 rounded-0\">\r\n        <div class=\"mb-3 font-weight-bold\">{{ marketplaceItem.DisplayName }}</div>\r\n        <div class=\"row\">\r\n          <div class=\"col-6 d-flex\">\r\n            <span class=\"icon material-icons reward-detail-icons\" aria-hidden=\"true\">emoji_events</span>\r\n            <label class=\"accessibility-only\">Points Value: </label>\r\n            <span class=\"pl-1 font-weight-normal\">{{ marketplaceItem.PointValue | FortressCurrencyPipe: 'PTS' }}</span>\r\n          </div>\r\n          <div class=\"col-6 d-flex\">\r\n            <span class=\"icon material-icons reward-detail-icons\" aria-hidden=\"true\">local_offer</span>\r\n            <label class=\"accessibility-only\">Stock Availability: </label>\r\n            <span class=\"pl-1 font-weight-normal\">\r\n              {{ marketplaceItem.AvailabilityCount }}\r\n              <span aria-hidden=\"true\">/</span>\r\n              <label class=\"accessibility-only\">Out of</label>\r\n              {{ marketplaceItem.StockCount }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"cta {{ 'bg-' + theme }} {{ 'text-on-' + theme }}\">\r\n      <span class=\"mx-1 font-weight-bold\">{{ statusText | translate }}</span>\r\n    </div>\r\n  </div>\r\n</a>\r\n",
                styles: [""]
            }]
    }], function () { return []; }, { ignoreLink: [{
            type: Input
        }], marketplaceItem: [{
            type: Input
        }] }); })();

class MarketplaceListItemModule {
}
MarketplaceListItemModule.ɵfac = function MarketplaceListItemModule_Factory(t) { return new (t || MarketplaceListItemModule)(); };
MarketplaceListItemModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: MarketplaceListItemModule });
MarketplaceListItemModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            LoyaltyIconModule,
            PipesModule,
            DirectivesModule,
            RouterModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(MarketplaceListItemModule, { declarations: function () { return [MarketplaceListItemComponent]; }, imports: function () { return [CommonModule,
        LoyaltyIconModule,
        PipesModule,
        DirectivesModule,
        RouterModule, ɵngcc5.TranslateModule]; }, exports: function () { return [MarketplaceListItemComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MarketplaceListItemModule, [{
        type: NgModule,
        args: [{
                declarations: [MarketplaceListItemComponent],
                imports: [
                    CommonModule,
                    LoyaltyIconModule,
                    PipesModule,
                    DirectivesModule,
                    RouterModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [MarketplaceListItemComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { MarketplaceListItemComponent, MarketplaceListItemModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-loyalty-marketplace-marketplace-list-item.js.map